<div class="modal-header">
  @if (!data.headerMessage) {
    <h2 mat-dialog-title>There has been an error completing this request.</h2>
  }
  @if (data.headerMessage) {
    <h2 mat-dialog-title [innerHTML]="data.headerMessage"></h2>
  }
  <button type="button" class="close-button" mat-dialog-close aria-label="Close modal"><span class="ion-android-close" area-hidden="true"></span></button>
</div>
<mat-dialog-content>
  @for (errMsg of data.errorMessages; track errMsg) {
    <p [innerHTML]="errMsg.description || errMsg.message || errMsg"></p>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button type="button" class="button" mat-dialog-close>Okay</button>
</mat-dialog-actions>
